import React from 'react';

const StarIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
  className = '',
  ...props
}) => (
  <svg className={className} fill='currentColor' viewBox='0 0 20 20' {...props}>
    <path d='M10 2l2.39 4.84 5.34.78-3.86 3.76.91 5.32L10 13.27l-4.78 2.51.91-5.32-3.86-3.76 5.34-.78z' />
  </svg>
);

export default StarIcon;
